import React, { useState, useEffect, useCallback } from 'react';
import alert_A_bg from './Images/ImagesForAlert/alert_A_bg.png';
import alert_close_n from './Images/ImagesForAlert/alert_close_n.png';
import ok_n from './Images/ImagesForAlert/ok_n.png';
import ok_o from './Images/ImagesForAlert/ok_o.png';

interface CustomAlertProps {
    message: string;
    onClose: () => void;
}

const CustomAlert: React.FC<CustomAlertProps> = ({ message, onClose }) => {
    const [isOkHovered, setIsOkHovered] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [offset, setOffset] = useState({ x: 0, y: 0 });

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        setIsDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        });
    };

    const handleMouseMove = useCallback((e: MouseEvent) => {
        if (isDragging) {
            setPosition({
                x: e.clientX - offset.x,
                y: e.clientY - offset.y
            });
        }
    }, [isDragging, offset]);

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    useEffect(() => {
        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        } else {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        }
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, handleMouseMove]);

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(204, 204, 204, 0.5)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: isDragging ? 'all' : 'auto'
        }}>
            <div style={{
                width: '506px',
                height: '246px',
                backgroundImage: `url(${alert_A_bg})`,
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                fontFamily: 'Tahoma',
                fontSize: '14px',
                color: 'white',
                transform: `translate(${position.x}px, ${position.y}px)`,
                userSelect: 'none'
            }}>
                <div 
                    onMouseDown={handleMouseDown}
                    style={{
                        width: '100%',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingLeft: '15px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        position: 'relative',
                        cursor: isDragging ? 'move' : 'move'
                    }}
                >
                    Warning
                    <img
                        src={alert_close_n}
                        alt="Close"
                        onClick={onClose}
                        onMouseDown={(e) => e.stopPropagation()}
                        style={{
                            position: 'absolute',
                            right: '15px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer'
                        }}
                    />
                </div>

                <div style={{
                    height: '145px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 20px',
                    color: 'black',
                    overflowY: 'auto',
                    textAlign: 'center'
                }}>
                    <div dangerouslySetInnerHTML={{ __html: message }} />
                </div>

                <div style={{
                    height: '70px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <img
                        src={isOkHovered ? ok_o : ok_n}
                        alt="OK"
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={() => setIsOkHovered(true)}
                        onMouseLeave={() => setIsOkHovered(false)}
                        onClick={onClose}
                    />
                </div>
            </div>
        </div>
    );
};

export default CustomAlert;

// const [alertInfo, setAlertInfo] = useState({ show: false, message: '', isSuccess: false });
// if (selectedItems.length === 0) {
//     setAlertInfo({ show: true, message: "Please select at least one lesson." });
//     return;
// }
// {alertInfo.show && (
//     <CustomAlert 
//         message={alertInfo.message} 
//         onClose={() => setAlertInfo({ ...alertInfo, show: false })} 
//     />
// )}